@if (!user) {
  <ftr-icon icon="AccountCircle" [size]="size" color="GreyLight" align="Sub"></ftr-icon>
}

@if (user) {
  <div class="user-avatar" [ngClass]="['user-avatar--' + (size | lowercase), 'user-avatar--' + color]">
    {{ userInitials ?? '' | uppercase }}
  </div>
}
